import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=2f2a3388&"
import script from "./ProgressBar.vue?vue&type=script&lang=js&"
export * from "./ProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=2f2a3388&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports